import { ActionType } from "@ms/uno-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for PremiumPlanPermissionsStore, for use in the registry */ export const PremiumPlanPermissionsStoreActionTypes = [
    ActionType.FetchUserFeatureEntitlementsAction,
    ActionType.FetchUserFeatureEntitlementsFailedAction,
    ActionType.FetchUserFeatureEntitlementsSucceededAction,
    ActionType.UpdateUserFeatureEntitlementsAction,
    ActionType.FetchTenantFeatureSettingsSucceededAction
];
